import { footerData } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div className="sm:col-span-2 lg:col-span-1">
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center flex-shrink-0">
                  <i className="ri-play-circle-fill text-background-50 text-xl"></i>
                </div>
                <span className="font-heading text-xl text-background-50">黄桃视频</span>
              </div>
              <p className="text-foreground-300 text-sm leading-relaxed">
                {footerData.description}
              </p>
            </div>

            {footerData.links.map((group) => (
              <div key={group.title}>
                <h4 className="font-heading text-base text-background-50 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-2.5">
                  {group.items.map((item) => (
                    <li key={item}>
                      <a
                        href={`#${item}`}
                        className="text-sm text-foreground-300 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                      >
                        {item}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-foreground-800">
            <div className="mb-6">
              <h4 className="font-heading text-base text-background-50 mb-3">{footerData.partners.title}</h4>
              <div className="flex flex-wrap gap-3">
                {footerData.partners.items.length === 0 ? (
                  <span className="text-sm text-foreground-400">合作伙伴招募中，敬请期待...</span>
                ) : (
                  footerData.partners.items.map((partner, idx) => (
                    <span key={idx} className="text-sm text-foreground-400">{partner}</span>
                  ))
                )}
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-foreground-400">
                {footerData.copyright}
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">服务条款</a>
                <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">隐私政策</a>
                <a href="#" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer">免责声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}